// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"24":"component---src-templates-buy-sell-crypto-24-tsx","869":"styles"}[chunkId] + "-" + {"24":"a6cb6dc493f32be92723","869":"c0d14664d79c21251b10"}[chunkId] + ".js";
};